
// => Styling
import styles from './CardPreview.module.css';

// => Utils
import { findClipById } from '../../../util/Utils';

// => Data
import cards from '../../../content/cards.json';
import baseClips from '../../../content/baseClips.json';    // TODO: import all clip data here
import xpacClips from '../../../content/xpacClips.json';


// ============
// Component
// ============
const CardPreview = ({
    data = cards.test[0],
    index = 0,
    unlocked = false,
    onInspect = (d, i) => {},
}) => {

    const cardNumIndex = () => {
        return (index+1).toString().padStart(3, '0')
    }

    /*const findClip = (id) => {
        // Combine base clips to search for
        let all = baseClips.babes.concat(baseClips.cocks, baseClips.shots)
        // TODO: Combine clips from all sets
        all = all.concat(xpacClips.bbc_deluxe)

        // Find id we're looking for
        return all.find((c) => c.id === id)
    }*/

    const cardBack = () => {
        return(
            <div className={[styles.container, styles.backside].join(" ")}>
                <div className={styles.cardIndex}>{cardNumIndex()}</div>
                <div className={styles.unknown}>?</div>
            </div>
        );
    }

    const cardFront = () => {
        return(
            <div className={[styles.container, styles.frontside].join(" ")} onClick={()=>onInspect(data, index)}>
                <div className={styles.cardIndex}>{cardNumIndex()}</div>
                <img className={styles.poster} src={findClipById(data.clip).thumb} alt="" />
                {cardFrontFx()}
            </div>
        )
    }

    const cardFrontFx = () => {
        let result = data.rarity > 0 ? (
            <img className={styles.fxRare} src="assets/img/cards/previewCard_frontfx_rare.png" alt="" />
        ) : (
            <img className={styles.fxCommon} src="assets/img/cards/previewCard_frontfx_common.png" alt="" />
        )
        return result
    }

    const getCard = () => {
        return unlocked ? cardFront() : cardBack()
    }


    // RENDER
    // ---------
    return getCard();
}


export default CardPreview